import React from 'react';
import Icon from '../../../components/AppIcon';

const FilePreviewCard = ({ file, onRemove }) => {
  const formatFileSize = (bytes) => {
    if (!bytes || bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  };

  const getFileIcon = (fileName) => {
    const ext = fileName?.split('.')?.pop()?.toLowerCase();
    if (ext === 'pptx' || ext === 'ppt') return 'Presentation';
    if (ext === 'pdf') return 'FileText';
    return 'File';
  };

  const getFileColor = (fileName) => {
    const ext = fileName?.split('.')?.pop()?.toLowerCase();
    if (ext === 'pptx' || ext === 'ppt') return '#d97706';
    if (ext === 'pdf') return '#dc2626';
    return '#004AAD';
  };

  const fileColor = getFileColor(file?.name);

  return (
    <div style={{
      background: 'var(--card, #ffffff)',
      border: '1px solid var(--border, #e2e8f0)',
      borderRadius: 14, padding: '16px 18px',
      fontFamily: 'inherit',
      transition: 'box-shadow 0.15s',
    }}
      onMouseEnter={e => e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'}
      onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 14 }}>

        {/* File icon */}
        <div style={{
          width: 48, height: 48, borderRadius: 10, flexShrink: 0,
          background: `${fileColor}15`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <Icon name={getFileIcon(file?.name)} size={22} color={fileColor} />
        </div>

        {/* File info */}
        <div style={{ flex: 1, minWidth: 0 }}>
          <h4 style={{
            fontFamily: 'inherit', fontSize: 13, fontWeight: 600,
            color: 'var(--foreground, #0f172a)',
            margin: '0 0 3px',
            overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          }}>
            {file?.name}
          </h4>
          <p style={{ fontFamily: 'inherit', fontSize: 12, color: 'var(--muted-foreground, #64748b)', margin: 0 }}>
            {formatFileSize(file?.size)}
          </p>

          {file?.type === 'link' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6 }}>
              <Icon name="Link" size={13} color="var(--muted-foreground, #94a3b8)" style={{ flexShrink: 0 }} />
              <span style={{
                fontFamily: 'inherit', fontSize: 11,
                color: 'var(--muted-foreground, #64748b)',
                overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
              }}>{file?.url}</span>
            </div>
          )}
        </div>

        {/* Remove button */}
        <button
          onClick={onRemove}
          aria-label="Remove file"
          style={{
            flexShrink: 0, width: 30, height: 30, borderRadius: 8,
            border: '1px solid var(--border, #e2e8f0)',
            background: 'transparent', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: 'var(--muted-foreground, #94a3b8)',
            transition: 'border-color 0.15s, color 0.15s, background 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.borderColor = '#dc2626'; e.currentTarget.style.color = '#dc2626'; e.currentTarget.style.background = 'rgba(220,38,38,0.05)'; }}
          onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border, #e2e8f0)'; e.currentTarget.style.color = 'var(--muted-foreground, #94a3b8)'; e.currentTarget.style.background = 'transparent'; }}
        >
          <Icon name="X" size={14} />
        </button>
      </div>

      {/* Upload progress */}
      {file?.uploadProgress !== undefined && file?.uploadProgress < 100 && (
        <div style={{ marginTop: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
            <span style={{ fontFamily: 'inherit', fontSize: 12, color: 'var(--muted-foreground, #64748b)' }}>Uploading...</span>
            <span style={{ fontFamily: 'inherit', fontSize: 12, fontWeight: 600, color: '#004AAD' }}>
              {file?.uploadProgress}%
            </span>
          </div>
          <div style={{
            width: '100%', height: 6, borderRadius: 100,
            background: 'var(--muted, #f1f5f9)', overflow: 'hidden',
          }}>
            <div style={{
              height: '100%', borderRadius: 100,
              width: `${file?.uploadProgress}%`,
              background: 'linear-gradient(135deg, #004AAD 0%, #0082FB 100%)',
              transition: 'width 0.3s ease',
            }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FilePreviewCard;